/* @flow */

import { makeIDLink } from './utils';

export default makeIDLink({ pathname: '/cases' });



// WEBPACK FOOTER //
// ./src/packages/@ncigdc/components/Links/CaseLink.js